import { render, staticRenderFns } from "./combos.vue?vue&type=template&id=c6980276&"
import script from "./combos.vue?vue&type=script&lang=js&"
export * from "./combos.vue?vue&type=script&lang=js&"
import style0 from "./combos.vue?vue&type=style&index=0&id=c6980276&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports